import { CheckCircleFilled } from '@ant-design/icons';
import colorTokens from '../../constants/design_system/colors';
import { Progress } from 'antd';
import { useContext } from 'react';
import { ModalContext, ModalType } from '../../context/ModalContext';
import Task from '../../types/Task';
import { TaskType } from '../../types/TaskType';
import { buildAddSubitemModalProps } from '../Modal/createItemSpace';
import './ProgresLabel.scss';

type ProgressLabelProps = {
  task: Task | undefined;
  completedSubtasks: number;
  subtasks: number;
};

const ProgressLabel = ({ task, completedSubtasks, subtasks }: ProgressLabelProps) => {
  const { openModal } = useContext(ModalContext);

  return (
    <div className="h-full flex items-center justify-center gap-1 progress-label">
      <div
        className="text-neutral-900 text-sm font-medium progress-label__add_subtask"
        onClick={() => {
          if (!task) return;
          openModal(ModalType.CreateItem, buildAddSubitemModalProps(task));
        }}
      >
        {task?.type === TaskType.epic ? 'Add Item' : 'Add Subitem'}
      </div>
      {subtasks > 0 && (
        <div className={`w-4 h-4 flex items-center progress-label__progress pl-1`}>
          {completedSubtasks < (subtasks ?? 0) && (
            <Progress
              type="circle"
              percent={subtasks ? Math.round((completedSubtasks / subtasks) * 100) : 0}
              size={16}
              strokeWidth={10}
              showInfo={false}
              strokeColor={colorTokens.brand['taskonio-green']}
              trailColor={colorTokens.neutral['600']}
            />
          )}
          {completedSubtasks === subtasks && (
            <div className="w-4 h-4 flex items-center justify-center text-neutral-900 text-xs font-semibold p-0.5">
              <CheckCircleFilled style={{ fontSize: '16px' }} className="text-taskonioGreen-600" />
            </div>
          )}
        </div>
      )}
      {subtasks > 0 && (
        <div
          className={`flex items-center justify-center text-neutral-900 text-xs font-semibold pl-1 progress-label__progress`}
        >
          {completedSubtasks}/{subtasks}
        </div>
      )}
      {subtasks === 0 && (
        <div className="justify-start text-neutral-700 text-sm font-normal leading-tight progress-label__progress">
          {task?.type === TaskType.epic ? 'No Items' : 'No Subitems'}
        </div>
      )}
    </div>
  );
};

export default ProgressLabel;
